const rawBaseUrl = import.meta.env.VITE_API_URL;
const rawHomeUrl = import.meta.env.VITE_HOME_URL;
const rawWSUrl = import.meta.env.VITE_WS_URL;
export const BASE_URL = rawBaseUrl ? rawBaseUrl.replace(/\/+$/, '') : '';
export const HOME_URL = rawHomeUrl ? rawHomeUrl.replace(/\/+$/, '') : '';
export const WS_URL = rawWSUrl ? rawWSUrl.replace(/\/+$/, '') : '';
export const DEFAULT_VERSION = import.meta.env.VITE_DEFAULT_VERSION!;
export const SUPPORTED_LOCALES = ['en', 'nl'];
